var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineArrowDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "vuesax/outline/message-notif"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Arrow - Right 2",
    d: "M6.102 7.863a.408.408 0 01.538-.041l.046.041L10 11.239l3.313-3.376a.408.408 0 01.539-.041l.046.041a.428.428 0 01.04.549l-.04.047-3.606 3.68a.408.408 0 01-.538.041l-.046-.041-3.606-3.68a.428.428 0 010-.596z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5
  }))));
}
export default SvgVuesaxOutlineArrowDown;